export const PROCESSING = 'PROCESSING';
export const GET_RESOURCES = 'GET_RESOURCES';
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
